import {
  Container,
  Stack,
  styled,
  Box,
  ListItem,
  IconButton,
  useMediaQuery,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import logoFull from "../../resources/images/logo_full.svg";
import { HashLink } from "react-router-hash-link";
import { useState } from "react";
import { Equal } from "lucide-react";
import background from "../../resources/images/background.png";

const Image = styled("img")``;

const StyledLink = styled(HashLink)(({ theme }) => ({
  color: "white",
  textDecoration: "none",
  fontWeight: 500,
  fontSize: "18px",
  cursor: "pointer",
  lineHeight: "21.6px",
  letterSpacing: "0%",
}));

const headerList = [
  ["Home", "/"],
  ["Careers", "/careers"],
  ["Contact us", "/contact-us"],
];

const DrawerList = ({ setOpenDrawer }) => {
  return (
    <Box
      sx={{
        width: 200,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        zIndex: 1,
      }}
      role="presentation"
    >
      <List>
        {headerList.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              onClick={() => setOpenDrawer(false)}
              LinkComponent={HashLink}
              smooth
              to={item[1]}
            >
              <ListItemText
                primary={item[0]}
                sx={{
                  "& .MuiTypography-root": {
                    color: "white",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

const Header = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = useMediaQuery("(max-width:600px)");

  return (
    <header>
      <Container maxWidth={"xl"}>
        <Stack
          direction={"row"}
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            mx: { md: "56px", sm: "20px", xs: "4px" },
            my: "20px",
          }}
        >
          <Box>
            <StyledLink to={"/"}>
              <Image
                src={logoFull}
                alt="logo"
                sx={{
                  width: { xs: "191px", sm: "auto", position: "relative" },
                }}
              />
            </StyledLink>{" "}
          </Box>
          {showDrawer ? (
            <>
              <IconButton
                sx={{ p: 0 }}
                onClick={() => setOpenDrawer(!openDrawer)}
              >
                <Equal color="white" />
              </IconButton>
              <Drawer
                anchor="right"
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
              >
                <DrawerList setOpenDrawer={setOpenDrawer} />
              </Drawer>
            </>
          ) : (
            <Box display={"flex"} gap={4}>
              {headerList.map((item, _) => (
                <StyledLink key={item[0]} to={item[1]}>
                  {item[0]}
                </StyledLink>
              ))}
            </Box>
          )}
        </Stack>
      </Container>
    </header>
  );
};

export default Header;
